/** Interconnected orgs that share JJC fax intake and cross-org patient lookup. */
export const JJC_INTERCONNECTED_ORGS = [
  'jack_health',
  'jill_health'
] as const;

export type JjcInterconnectedOrg = (typeof JJC_INTERCONNECTED_ORGS)[number];

export function isJjcInterconnectedOrg(org: string): org is JjcInterconnectedOrg {
  return (JJC_INTERCONNECTED_ORGS as readonly string[]).includes(org);
}

/**
 * Single source of truth mapping a receiving RingCentral fax number to the org
 * that owns that line. Consumed by both the JJC middleware fax webhook
 * (JjcRingCentralService) and RingCentralAdapter.handleWebhook so the two can
 * no longer drift out of sync.
 */
export const JJC_FAX_NUMBER_TO_ORG: Record<string, JjcInterconnectedOrg> = {
  '+18559522436': 'jack_health',
  '+18554774220': 'jill_health'
};
